import styled from "styled-components";

export const Header = styled.h4`
  padding: 0;
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 5px;
  margin-top: 5px;
`;
export const Descriptation = styled.div`
  padding: 0;
  margin: 0;
  padding-top: 5px;
  padding-bottom: 15px;
  font-size: 14px;
  color: #716c80;
`;
